import { useState } from "react";

import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogFooter,
  DialogHeader,
  DialogPopup,
  DialogTitle,
} from "~/components/ui/dialog";
import { Input } from "~/components/ui/input";

/** Asks for a new name; Save is only possible for a real change. */
export function RenameDialog(props: {
  currentName: string;
  heading: string;
  inputLabel: string;
  onOpenChange: (open: boolean) => void;
  onRename: (name: string) => void;
  open: boolean;
}) {
  const [name, setName] = useState(props.currentName);
  return (
    <Dialog
      open={props.open}
      onOpenChange={(open) => {
        if (open) setName(props.currentName);
        props.onOpenChange(open);
      }}
    >
      <DialogPopup>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            props.onRename(name);
            props.onOpenChange(false);
          }}
        >
          <DialogHeader>
            <DialogTitle>{props.heading}</DialogTitle>
          </DialogHeader>
          <div className="px-6 pb-2">
            <Input
              aria-label={props.inputLabel}
              autoFocus
              maxLength={120}
              onChange={(event) => setName(event.target.value)}
              value={name}
            />
          </div>
          <DialogFooter>
            <DialogClose render={<Button type="button" variant="outline" />}>Cancel</DialogClose>
            <Button disabled={!name.trim() || name.trim() === props.currentName} type="submit">
              Save
            </Button>
          </DialogFooter>
        </form>
      </DialogPopup>
    </Dialog>
  );
}
